import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth/auth.service';

export const isAuthenticatedGuard: CanActivateFn = () => {
  const token = inject(AuthService).token();
  const router = inject(Router);
  const platform = inject(PLATFORM_ID);

  if (isPlatformServer(platform)) {
    return true;
  }

  return token ? true : router.navigate(['/']);
};
